/**
 * User store.
 *
 * @author          David Gustavssonb
 * @description     This store will handle all logic related to the active user.
 */
'use strict';

import { UserCompaniesResponse } from '../../../typings/api/skymap/rest/v0/company';
import { SkyMapAxiosServiceFactory } from '../services/axios/skymap-axios-service-factory';
import { isDefined } from '../utils/variables';

export type UserCompanies = UserCompaniesResponse['data'];

export class CompanyStore {
  static get instance() {
    return CompanyStore._instance;
  }

  private constructor() {
    /*  */
  }

  private static _instance: CompanyStore = new CompanyStore();
  private user?: { id: string; organizationAdmin: boolean };
  private companies?: UserCompanies;

  async fetchCompanies(userId = this.user?.id, organizationAdmin = false): Promise<void> {
    if (!userId) {
      this.companies = undefined;
      return;
    }

    this.user = { id: userId, organizationAdmin };

    if (organizationAdmin) {
      this.companies = [];
    }

    const companyService = SkyMapAxiosServiceFactory.instance.createCompanyServiceV0();
    const { data: companies } = await companyService.fetchUserCompanies({ query: { id: userId } });

    this.companies = companies;
  }

  getCompanies() {
    return this.companies;
  }

  isCompaniesLoaded() {
    return !!this.companies;
  }

  getCompanyCountry(companyId: string) {
    return this.companies?.find((company) => company.id === companyId)?.country;
  }

  isCompanyAdmin(projectId?: string): boolean {
    if (!isDefined(this.companies) || this.companies.length === 0) {
      return false;
    }

    if (!projectId) {
      return true;
    }

    return this.companies.some((company) =>
      company.Projects.some((project) => project.id === projectId && project.status === 'ACTIVE'),
    );
  }
}
